import React from 'react'
import { Button } from 'react-bootstrap'

const TimerActionButton = ({ projectId, projectStatus, runningSince, onStartTimer, onStopTimer}) => {
    if(runningSince) {
        return (
            <Button variant="outline-danger" size="sm" onClick={() => onStopTimer(projectId)}>Stop Timer</Button>
        )
    }
  return (
    <Button variant="outline-success" size="sm" onClick={() => onStartTimer(projectId)}disabled={projectStatus === 'Completed'}>Start Timer</Button>
  )
}

export default TimerActionButton